// extracted by mini-css-extract-plugin
module.exports = {"root":"ClearentDisclaimer_root__3QZ8-","header":"ClearentDisclaimer_header__36JgQ","inner":"ClearentDisclaimer_inner__2OMe-"};